"use client";

import React from "react";
import {
  DropZoneUploadInput,
  DropZoneUploadInputProps
} from "../DropZoneUploadInput/DropZoneUploadInput";
import { FormControlWrapper } from "../FormControlWrapper";
import { splitFormControlWrapperProps } from "../FormControlWrapper/helpers";
import {
  ImageUploaderInputProps,
  ImageUploaderInputPropsWithFormControl
} from "./ImageUploaderInput.types";

/**
 * @deprecated Use DropZoneUploadInput instead for a consistent upload experience
 */
const ImageUploaderInputCore: React.FC<ImageUploaderInputProps> = ({
  recommendedSize,
  hint,
  // Deprecated props - ignored but accepted for backward compatibility
  fallback: _fallback,
  uploadLabel: _uploadLabel,
  changeLabel: _changeLabel,
  removeLabel: _removeLabel,
  accept: _accept,
  disabled: _disabled,
  ...rest
}) => {
  // Map legacy recommendedSize to hint
  const resolvedHint = hint || recommendedSize;

  const dropzoneProps: Omit<DropZoneUploadInputProps, "label" | "error"> = {
    ...rest,
    hint: resolvedHint,
    type: rest.type || "all-images"
  };

  return <DropZoneUploadInput {...dropzoneProps} />;
};

/**
 * @deprecated Use DropZoneUploadInput instead for a consistent upload experience
 */
export const ImageUploaderInput: React.FC<
  ImageUploaderInputPropsWithFormControl
> = (props) => {
  const [wrapperProps, inputProps] = splitFormControlWrapperProps(props);

  return (
    <FormControlWrapper variant="unstyled" {...wrapperProps}>
      <ImageUploaderInputCore {...inputProps} />
    </FormControlWrapper>
  );
};

ImageUploaderInput.displayName = "ImageUploaderInput";
